export default "__VITE_ASSET__CPQIR2em__"